/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react"
import { useParams } from 'react-router'
import GridContainer from '../components/GridContainer'
import Literal from "../literals/Literal"
import Header from '../components/Header'
import Image from '../components/Image'
import { FirestoreService } from '../lib/firestore'
import logoVote from '../assets/images/vote-for-your-weekend.svg'
import copy from '../assets/images/copy.svg'
import share from '../assets/images/share.svg'
import { useCookies } from 'react-cookie'
import ShareModal from '../components/ShareModal'


const Result = () => {
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(['vote'])
  const { groupId, groupName } = useParams()
  const [teamName, setTeamName] = useState(groupName)
  const [voterName, setVoterName] = useState()
  const [vote, setVote] = useState()
  const [results, setResults] = useState([0,0,0])
  const [resultsGraphic, setResultsGraphic] = useState([0,0,0])
  const [voters, setVoters] = useState()
  const [votersNumber, setVotersNumber] = useState([0,0,0])
  const [winnerPoster, setWinnerPoster] = useState()
  const [openModal, setOpenModal] = useState(false)
  const urlInput = useRef()

  const options = [
    <span className="px-1 bg-gradient-to-r font-secondary from-options-orange"><span className="text-options-brown mix-blend-color-burn">{Literal('OPTION_1')}</span></span>,
    <span className="px-1 bg-gradient-to-r font-secondary from-options-green"><span className="text-options-blue mix-blend-color-burn">{Literal('OPTION_2')}</span></span>,
    <span className="px-1 bg-gradient-to-r font-secondary from-options-violet"><span className="text-options-purple mix-blend-color-burn">{Literal('OPTION_3')}</span></span>, 
  ]

  const getTeamName = async () => {
    const db = await new FirestoreService()
    db.getTeam(groupId).then(result => {

      const rawVoters = []
      result.votes.map(v => {
        if (typeof rawVoters[v.vote] !== 'undefined') {
          rawVoters[v.vote] = `${rawVoters[v.vote]}, ${v.name}`
        } else {
          rawVoters[v.vote] = `${v.name}`
        }
        return true
      })
      setVoters(rawVoters)

      const votesFor1 = result.votesFor1 || 0
      const votesFor2 = result.votesFor2 || 0
      const votesFor3 = result.votesFor3 || 0

      const maxVotes = Math.max(votesFor1, votesFor2, votesFor3) || 0
      const totalVotes = result.votesTotal || 0

      if (votesFor1 === maxVotes) {
        setWinnerPoster('1')
      }
      if (votesFor2 === maxVotes) {
        setWinnerPoster('2')
      } 
      if (votesFor3 === maxVotes || (votesFor1 === maxVotes && votesFor2 === maxVotes)) { 
        setWinnerPoster('3')
      }

      setVotersNumber([votesFor1, votesFor2, votesFor3])

      if (totalVotes !== 0) {
        setResultsGraphic([
          Number((votesFor1 * 100 / maxVotes)).toFixed(0),
          Number((votesFor2 * 100 / maxVotes)).toFixed(0),
          Number((votesFor3 * 100 / maxVotes)).toFixed(0),
        ])
  
        setResults([
          Number((votesFor1 * 100 / totalVotes)).toFixed(0),
          Number((votesFor2 * 100 / totalVotes)).toFixed(0),
          Number((votesFor3 * 100 / totalVotes)).toFixed(0),
        ])
      }

      if (result.name) {
        setTeamName(result.name)
      }
    }).catch((error) => console.log(error))
  }
  
  useEffect(() => {
    const vote = cookies[`ps-vote-${groupId}`]
    if (vote && vote.team === groupId) {
      setVoterName(vote.voterName)
      setVote(options[vote.vote - 1])
    }
    getTeamName()
  }, [])


  useEffect(() => {
    if (openModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'initial'
    }
  }, [openModal])


  const currentURL = window.location.href
  const url = currentURL.replace('result', 'vote')

  const copyToClipboard = () => {
    const input = urlInput.current
    input.select()
    document.execCommand('copy')
  }

  return (
    <>
      {openModal &&  <div className="fixed top-0 bottom-0 left-0 right-0 z-10">
        <div className="relative flex items-center justify-center w-full h-full">
          <div className="fixed z-10 w-full h-full bg-white bg-opacity-50" onClick={() => setOpenModal(false)} />
          <ShareModal open={openModal} url={url} onClose={() => setOpenModal(false)}/>
        </div>
      </div>
      }
      <Header showLogo={true} />
      <div className={`${(voters) ? 'opacity-100' : 'opacity-0'} transition-opacity duration-200`}>
        <GridContainer>
          <Image option={winnerPoster}/>
          <div className={`flex flex-col items-start justify-center col-span-4 col-start-1 sm:col-start-2 sm:col-span-2 md:col-span-4 md:col-start-2`}>
            <div className="self-center w-full max-w-md px-12 py-6 sm:px-4 md:hidden">
              <img src={logoVote} alt="VOTE YOUR WEEKEND" className="w-full"/>
            </div>
            <div className={`w-full font-secondary text-2xl sm:text-6xl md:text-5xl xl:text-6xl`}>{teamName}</div>
            <div className={`flex flex-wrap text-md sm:text-lg lg:text-xl xl:text-2xl flex items-center ${(!vote) ? 'opacity-0 mb-0' : 'mb-4 sm:mb-6 md:mb-8'}`}>{`${voterName} → `}<span className="px-1 uppercase font-secondary">{Literal('RESULT_VOTED')}</span> {vote}</div>
            <div className="flex flex-col items-start w-full mb-4 sm:mb-6 md:mb-12">
              <div className="w-full mb-2 sm:mb-0">
                <div className="text-2xl lg:text-3xl xl:text-4xl font-secondary text-results-orange">{Literal('OPTION_1')}</div>
                <div className="px-2 mb-1 text-right text-white rounded-full lg:mb-2 bg-results-orange font-secondary" style={{ width: `${resultsGraphic[0]}%`, minWidth: '32px', transition: 'width 1s ease-out' }}>{results[0]}%</div>
                <div className="md:text-md">{`${(voters && voters[1]) || Literal('RESULT_NOBODY')} ${votersNumber[0] > 1 ?Literal('RESULT_CHOSE_PLURAL') : Literal('RESULT_CHOSE_SINGULAR')}`}</div>
              </div>
              <div className="w-full mb-2 sm:mb-0">
                <div className="text-2xl lg:text-3xl xl:text-4xl font-secondary text-results-green">{Literal('OPTION_2')}</div>
                <div className="px-2 mb-1 text-right text-white rounded-full lg:mb-2 bg-results-green font-secondary" style={{ width: `${resultsGraphic[1]}%`, minWidth: '32px', transition: 'width 1s ease-out' }}>{results[1]}%</div>
                <div className="md:text-md">{`${(voters && voters[2]) || Literal('RESULT_NOBODY')} ${votersNumber[1] > 1 ?Literal('RESULT_CHOSE_PLURAL') : Literal('RESULT_CHOSE_SINGULAR')}`}</div>
              </div>
              <div className="w-full mb-2 sm:mb-0">
                <div className="text-2xl lg:text-3xl xl:text-4xl font-secondary text-results-purple">{Literal('OPTION_3')}</div>
                <div className="px-2 mb-1 text-right text-white rounded-full lg:mb-2 bg-results-purple font-secondary" style={{ width: `${resultsGraphic[2]}%`, minWidth: '32px', transition: 'width 1s ease-out' }}>{results[2]}%</div>
                <div className="md:text-md">{`${(voters && voters[3]) || Literal('RESULT_NOBODY')} ${votersNumber[2] > 1 ?Literal('RESULT_CHOSE_PLURAL') : Literal('RESULT_CHOSE_SINGULAR')}`}</div>
              </div>
            </div>
            <div className="flex flex-col items-start justify-start sm:items-end sm:flex-row">
              <div>
                <div className="mb-2 leading-tight text-md sm:text-lg lg:text-xl">{Literal('RESULT_SHARE_URL')}</div>
                <input ref={urlInput} type="test" value={url} className="w-full h-12 p-2 border border-button-red md:text-md borde rounded-xl" readOnly/>
              </div>
              <div className="flex flex-row items-center justify-center pt-4 ml-4 sm:pt-0 sm:pb-4">
                <div className="w-5 mr-4 cursor-pointer md:w-4 lg:w-6" onClick={() => copyToClipboard()}>
                  <img src={copy} alt="copy" className="w-full"/>
                </div>
                <div className="w-5 cursor-pointer md:w-4 lg:w-6" onClick={() => setOpenModal(true)}>
                  <img src={share} alt="share" className="w-full"/>
                </div>
              </div>
            </div>
          </div>
        </GridContainer>
      </div>
    </>
  )
}

export default Result